var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0104 17.3007C14.7176 17.5936 14.7176 18.0685 15.0104 18.3614C15.3033 18.6543 15.7782 18.6543 16.0711 18.3614L20.7745 13.658C20.9156 13.5169 20.9947 13.3253 20.9941 13.1256C20.9936 12.926 20.9135 12.7348 20.7716 12.5945L16.0574 7.93179C15.7629 7.6405 15.2881 7.64311 14.9968 7.93761C14.7055 8.2321 14.7081 8.70697 15.0026 8.99825L18.4319 12.3901L6.25633 12.3901C5.84212 12.3901 5.50633 12.7259 5.50633 13.1401C5.50633 13.5543 5.84212 13.8901 6.25634 13.8901L18.421 13.8901L15.0104 17.3007Z",
    fill: "url(#paint0_linear_3165_5873)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3165_5873",
    x1: 7.50024,
    y1: 15.9999,
    x2: 16.7369,
    y2: 8.21943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowRight);
export default __webpack_public_path__ + "static/media/longArrowRight.df3f2339afb32d291f421823f142aeb3.svg";
export { ForwardRef as ReactComponent };